import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const NextArrow = (props: SvgProps) => (
  <Svg width={133.333} height={133.333} viewBox="0 0 100 100" {...props}>
    <Path d="M27.2 7.2c-.7.7-1.2 1.9-1.2 2.7 0 .9 8.7 10.2 19.2 20.8L64.5 50 45.2 69.3C34.7 79.9 26 89.2 26 90.1c0 1.9 2 3.9 4 3.9s44-42 44-44S31.9 6 29.9 6c-.8 0-2 .5-2.7 1.2z" />
  </Svg>
);
export default NextArrow;
